import {ReactNode, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Alert from '../../../common/component/Alert';
import AlertRadioButtonV4 from '../../../common/component/AlertRadioButtonV4';
import {ButtonSet} from '../../../common/type/alert';
import BottomButtonV4, {
  IBottomButtonVariant,
} from '../../common/component/BottomButtonV4';
import BottomButtonWrapperV4 from '../../common/component/BottomButtonWrapperV4';

interface IProps<T> {
  additionalButton?: ReactNode;
  itemList: Array<{key: T; text: string}>;
  selectedItemKey: T;
  bottomButtonIconVariant: IBottomButtonVariant;
  title: string;
  needTextTranslation?: boolean;
  onClick?: () => void;
  onClickConfirm: (key: T) => void;
  onClickCloseModal?: (isDimmedClicked?: boolean) => void;
  onSendViewImp?: () => void;
}

export default function FilterButtonV4<T>({
  additionalButton,
  itemList,
  selectedItemKey,
  bottomButtonIconVariant,
  title,
  needTextTranslation = false,
  onClick,
  onClickConfirm,
  onClickCloseModal,
  onSendViewImp,
}: IProps<T>) {
  const {t} = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [selectedRadioKey, setSelectedRadioKey] = useState(selectedItemKey);
  const selectedItemText =
    itemList.find(({key}) => key === selectedItemKey)?.text ?? '';

  useEffect(() => {
    setSelectedRadioKey(selectedItemKey);
  }, [selectedItemKey, showModal]);

  useEffect(() => {
    showModal && onSendViewImp?.();
  }, [showModal, onSendViewImp]);

  return (
    <>
      <BottomButtonWrapperV4>
        {additionalButton}
        <BottomButtonV4
          onClick={() => {
            onClick?.();
            setShowModal(true);
          }}
          iconVariant={bottomButtonIconVariant}
          text={needTextTranslation ? t(selectedItemText) : selectedItemText}
        />
      </BottomButtonWrapperV4>
      <Alert
        isOpen={showModal}
        buttonSet={ButtonSet.CancelAndConfirm}
        title={title}
        titleClassName="ml-8 mb-8 s17-medium-white light:text-black"
        spaceClassName="px-18"
        isTextAlignCenter={false}
        desc={itemList.map(({key, text}, index) => (
          <AlertRadioButtonV4
            key={index}
            text={needTextTranslation ? t(text) : text}
            isSelected={key === selectedRadioKey}
            onClick={() => {
              setSelectedRadioKey(key);
            }}
          />
        ))}
        callback={() => {
          onClickConfirm(selectedRadioKey);
          setShowModal(false);
        }}
        onRequestClose={isDimmedClicked => {
          onClickCloseModal?.(isDimmedClicked);
          setShowModal(false);
        }}
      />
    </>
  );
}
